export default {
  "--color-default": "rgb(251, 251, 251)",
  "--color-default-inverse": "rgb(7, 42, 50)",
  "--color-primary": "rgb(7, 42, 50)",
  "--color-primary-active": "rgb(8, 54, 65)",
  "--color-primary-inverse": "rgb(251, 251, 251)",
  "--color-secondary": "rgb(192, 233, 79)",
  "--color-secondary-active": "rgb(184, 224, 75)",
  "--color-secondary-inverse": "rgb(13, 13, 13)",
  "--color-tertiary": "rgb(227, 97, 100)",
  "--color-tertiary-active": "rgb(28, 88, 47)",
  "--color-tertiary-inverse": "rgb(251, 251, 251)",
  "--color-flame-pea": "rgb(243, 150, 107)",
  "--color-cerise": "rgb(142, 32, 78)",
  "--color-atlantis": "rgb(192, 233, 79)",
  "--color-calypso": "rgb(25, 108, 133)",
  "--color-blue-dianne": "rgb(7, 42, 50)",
  "--color-neutral-0": "rgb(23, 25, 28)",
  "--color-neutral-10": "rgb(38, 40, 44)",
  "--color-neutral-20": "rgb(70, 75, 83)",
  "--color-neutral-30": "rgb(94, 100, 110)",
  "--color-neutral-40": "rgb(106, 113, 124)",
  "--color-neutral-50": "rgb(145, 151, 161)",
  "--color-neutral-60": "rgb(172, 177, 185)",
  "--color-neutral-70": "rgb(200, 203, 208)",
  "--color-neutral-80": "rgb(227, 229, 232)",
  "--color-neutral-85": "rgb(238, 239, 241)",
  "--color-neutral-90": "rgb(244, 245, 246)",
  "--color-neutral-95": "rgb(249, 250, 250)",
  "--color-success": "rgb(82, 224, 105)",
  "--color-success-active": "rgb(72, 217, 95)",
  "--color-success-inverse": "rgb(251, 251, 251)",
  "--color-danger": "rgb(235, 71, 71)",
  "--color-danger-active": "rgb(227, 61, 61)",
  "--color-danger-inverse": "rgb(251, 251, 251)",
  "--color-warning-inverse": "rgb(251, 251, 251)",
  "--color-yellow-inverse": "rgb(251, 251, 251)",
  "--color-text": "rgb(7, 42, 50)",
  "--color-text-light": "rgb(145, 151, 161)",
  "--color-text-lighter": "rgb(172, 177, 185)",
  "--text-color-disabled": "rgb(200, 203, 208)",
  "--text-color-inverse": "rgb(249, 250, 250)",
  "--text-color-link": "rgb(7, 42, 50)",
  "--text-color-link-active": "rgb(8, 54, 65)",
  "--text-color-primary": "rgb(7, 42, 50)",
  "--text-color-primary-inverse": "rgb(251, 251, 251)",
  "--text-color-secondary": "rgb(192, 233, 79)",
  "--text-color-secondary-inverse": "rgb(13, 13, 13)",
  "--text-color-success": "rgb(82, 224, 105)",
  "--text-color-success-inverse": "rgb(251, 251, 251)",
  "--text-color-warning-inverse": "rgb(251, 251, 251)",
  "--text-color-danger": "rgb(235, 71, 71)",
  "--text-color-danger-inverse": "rgb(251, 251, 251)",
  "--background-color-soft": "rgb(249, 250, 250)",
  "--background-color-softer": "rgb(244, 245, 246)",
  "--background-color-softer-active": "rgb(249, 250, 250)",
  "--background-color-softest": "rgb(238, 239, 241)",
  "--background-color-softest-active": "rgb(244, 245, 246)",
  "--background-color-inverse": "rgb(23, 25, 28)",
  "--background-color-inverse-soft": "rgb(38, 40, 44)",
  "--background-color-inverse-softer": "rgb(70, 75, 83)",
  "--background-color-inverse-softer-active": "rgb(94, 100, 110)",
  "--background-color-disabled": "rgb(244, 245, 246)",
  "--background-color-primary": "rgb(7, 42, 50)",
  "--background-color-primary-active": "rgb(8, 54, 65)",
  "--background-color-primary-inverse": "rgb(251, 251, 251)",
  "--background-color-secondary": "rgb(192, 233, 79)",
  "--background-color-secondary-active": "rgb(184, 224, 75)",
  "--background-color-secondary-inverse": "rgb(13, 13, 13)",
  "--background-color-success": "rgb(82, 224, 105)",
  "--background-color-success-active": "rgb(72, 217, 95)",
  "--background-color-success-inverse": "rgb(251, 251, 251)",
  "--background-color-warning-inverse": "rgb(251, 251, 251)",
  "--background-color-danger": "rgb(235, 71, 71)",
  "--background-color-danger-active": "rgb(227, 61, 61)",
  "--background-color-danger-inverse": "rgb(251, 251, 251)",
  "--background-input-base": "rgb(227, 229, 232)",
  "--border-color-base": "rgb(227, 229, 232)",
  "--border-color-soft": "rgb(238, 239, 241)",
  "--border-color-softer": "rgb(244, 245, 246)",
  "--border-color-active": "rgb(7, 42, 50)",
  "--border-color-primary": "rgb(7, 42, 50)",
  "--border-color-success": "rgb(82, 224, 105)",
  "--border-color-danger": "rgb(235, 71, 71)",
  "--font-size-xxxxxl": "3.4375rem",
  "--font-size-xxxxl": "2.5rem",
  "--font-size-xxxl": "1.875rem",
  "--font-size-xl": "1.25rem",
  "--font-size-l": "1.125rem",
  "--font-text": "Inter, Helvetica, Arial, sans-serif",
  "--font-display": "SP Malton Sans, Raleway, Helvetica, Arial, sans-serif",
  "--font-weight-black": "900",
  "--font-weight-extrabold": "800",
  "--font-weight-bold": "700",
  "--line-height-m": "1.25",
  "--line-height-s": "1.1"
};